// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3XMAw","range":"MonthRangeSwitch_range__KK_Pl","disabled":"MonthRangeSwitch_disabled__13Vhs"};